import Product from '../../domains/Product'

import { EDDRequestProducts } from './eddService.types'

export const generateEDDProductPayload = (product: Product[]): EDDRequestProducts => {
  return product.reduce<EDDRequestProducts>((acc, curr) => {
    return [
      ...acc,
      {
        product_id: curr.id.toString(),
        variant_ids: curr.variants.map(variant => variant.id.toString()),
      },
    ]
  }, [])
}
